import { isDefined } from "@clipboard-health/util-ts";
import { Box } from "@mui/material";
import { CbhIcon, Image, LoadingSpinner } from "@src/appV2/redesign/system/ui-components";
import { useCallback, useState } from "react";

export interface ProfilePictureProps {
  isLoading: boolean;
  imageUrl: string | undefined;
}

export function ProfilePicture({ isLoading, imageUrl }: ProfilePictureProps) {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const handleImageLoaded = useCallback(() => {
    setIsImageLoaded(true);
  }, []);

  if (isLoading || !isDefined(imageUrl)) {
    return isLoading ? (
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LoadingSpinner size="medium" />
      </Box>
    ) : (
      <CbhIcon type="clipboard-bunny-colored" size="xLarge" />
    );
  }

  return (
    <Box
      sx={{
        width: 80,
        height: 80,
        borderRadius: "12px",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {!isImageLoaded && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LoadingSpinner size="medium" />
        </Box>
      )}
      <Image
        src={imageUrl}
        alt="Profile"
        width="100%"
        height="100%"
        sx={{ objectFit: "cover", opacity: isImageLoaded ? 1 : 0 }}
        onLoad={handleImageLoaded}
      />
    </Box>
  );
}
